var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHydraLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143 143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00c19f;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 71.5,
    cy: 71.5,
    r: 71.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.82,114.9h0c-1.25-13.79,3.53-30.4,33.2-31.64,0,0,21.41-3.68,11.69-12.34s-3.25-6.38-9.41-9.61-18.69.33-21.53.38S96,64.61,96.21,65s-5.77,1.78-7.31,2.51-5.39,6.77-4.47,8,3.58,1.32-.52,3.35c-.55.28-1.16.57-1.82.88-1.66-9.79,2.31-21,20-31,0,0,17.36-13.07,4.76-16.32s-5.81-4.2-12.76-4.25-16.48,8.84-19,10.19-2,4.32-1.63,4.54-4.32,4.22-5.36,5.57-1.7,8.49-.33,9.13,3.79-.46,1.08,3.22S60.8,71,61.34,72.4a53.65,53.65,0,0,1,1.2,5.4,14.06,14.06,0,0,1-.32,2.53c-1.14-.54-2.22-1.06-3.13-1.51-4.1-2-1.44-2.16-.51-3.35s-2.93-7.25-4.48-8S46.54,65.37,46.79,65s-.69-3.25-3.53-3.29-15.37-3.61-21.53-.38.31,1-9.41,9.61S24,83.27,24,83.27c29.66,1.24,34.44,17.85,33.19,31.64h0m33-80c.8-1.6,6.46-.05,6.46-.05C96.26,39.44,89.33,36.53,90.14,34.92ZM22.64,68.47s4.32-4,5.77-2.91S25,72.38,22.64,68.47Zm92-2.91c1.45-1.06,5.77,2.91,5.77,2.91C118,72.38,113.14,66.61,114.6,65.56Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydraLogo);
export default __webpack_public_path__ + "static/media/hydra-logo.215adcd6fae4dfb7e68eeccace50442f.svg";
export { ForwardRef as ReactComponent };